export const PrincipalFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'El estado es requerido',
      },
      {
        type: 'typeError',
        message: 'El estado es requerido',
      },
    ],
  },
  {
    name: 'internal_comments',
    inputType: 'textarea',
    colSize: 12,
    label: 'Comentario Interno',
    type: 'string',
    validations: [],
  },
  // {
  //   name: 'comments',
  //   inputType: 'textarea',
  //   colSize: 12,
  //   label: 'Comentario',
  //   type: 'string',
  //   validations: [],
  // },
  {
    name: 'attachments',
    inputType: 'attachments',
    invisible: true,
  },
]
